import { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Button, Fab, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDebounce } from "use-debounce";
import SearchBox from "../SearchBox";
import useIsLargeScreen from "../../hooks/useIsLargeScreen";
import AgenciesTable from "./AgenciesTable";
import { useAppPaths } from "../../Routes";


const AgenciesTableWithSearch = () => {
    const theme = useTheme();
    const isLargeScreen = useIsLargeScreen();
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [debounceSearchTerm] = useDebounce(searchTerm, 700);
    const appPaths = useAppPaths();

    return (
        <>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                marginTop: theme.spacing(3),
                justifyContent: "space-between",
                "& > *:not(:first-of-type)": {
                    marginLeft: 1,
                },
            }}>
                <SearchBox
                    placeholder="Search by Name"
                    onChange={setSearchTerm}
                    searchTerm={searchTerm}
                    sx={isLargeScreen ? { minWidth: "28rem", background: "#FFFFFF" } : { flexGrow: 1, background: "#FFFFFF" }}
                />
                {isLargeScreen && (
                    <Link to={appPaths.agencies.create} tabIndex={-1} style={{ textDecoration: "none", outline: "none", marginLeft: "1.25rem" }}>
                        <Button
                            size="medium"
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                        >
                            Create
                        </Button>
                    </Link>
                )}
            </Box>
            <Box sx={{ marginTop: "1.5rem" }}>
                <AgenciesTable
                    searchTerm={debounceSearchTerm}
                />
            </Box>
            {!isLargeScreen && (
                <Link to={appPaths.agencies.create}>
                    <Fab
                        color="primary"
                        aria-label="create-agency"
                        sx={{
                            position: "fixed",
                            bottom: theme.spacing(10),
                            right: theme.spacing(4),
                        }}
                    >
                        <AddIcon fontSize="large" />
                    </Fab>
                </Link>
            )}
        </>
    );
};
export default AgenciesTableWithSearch;